<script setup lang="ts">
import { ref } from 'vue';
import { useAffinityStore } from '@/features/Affinity';
import { FeedbackForm } from '@/features/FeedbackForm';
import { useFlowInitialization } from '@/features/flow/Flow';
import { getLocalePath } from '@/shared/utils/url-paths';
import FlowHeaderWidget from './FlowHeaderWidget.vue';
import FooterWidget from './FooterWidget.vue';

const { landingUrl = getLocalePath('/car-insurance') } = defineProps<{
  landingUrl?: string;
}>();

const emit = defineEmits<{ (e: 'goBack'): void }>();
function onGoBack() {
  emit('goBack');
}

const { withFeedback, showArrowBack } = useFlowInitialization({
  onBeforeMount: async () => {
    await useAffinityStore().checkAffinityCampaignAndGetInfo();
  },
});

// TODO: Events instead of prop?
const showFeedback = ref(withFeedback);
</script>

<template>
  <div class="flow-widget">
    <div class="flow-widget__top">
      <FlowHeaderWidget :url="landingUrl" :show-arrow-back="showArrowBack" @go-back="onGoBack" />
      <div class="flow-widget__content">
        <slot />
        <FeedbackForm v-if="showFeedback" v-model="showFeedback" data-test="feedback-form" />
      </div>
    </div>
    <div class="flow-widget__bottom">
      <FooterWidget />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@styles/utils' as *;

.flow-widget {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;

  &--primary {
    background-color: var(--colorBgSrfPrimary);
  }

  &__content {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-grow: 1;
  }

  &__logo {
    margin: 38px auto;
    height: 24px;
    width: 82px;
  }
}

.flow-widget__top {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}
</style>
